APPS.showlist.show = (function(){
    var show = function(id){
	    if(id === 1){
		   	$.when( Backbone.Radio.channel('entities').request('showlist',id) ).done(function( data ){
	            APP.getView().showChildView('mainRegion', new bingeView({
	                model:data
	            }) )
	        })
	    } else {
			$.when( Backbone.Radio.channel('entities').request('showlist',id) ).done(function( data ){
	            APP.getView().showChildView('mainRegion', new allKidsShowsView({
	                model:data
	            }) )
	        })    
	    }

    }

    
    /* VIEWS */
    // THE PAGE  
    var bingeView = Marionette.View.extend({
         template:_.template("<div><h1 class='mt2 mb0'>Passport Binge</h1><div id='binge-programsContainer'></div></div>")
        ,className:"binge_showlists"
        ,onRender: function() {	        
			var that = this;  
	        //get details for the programs they are associated with
        	try{
            	var showIds = JSON.parse(this.model.attributes.programIds);
            	
            	_.each(showIds,function(showId){
	            	$.when( Backbone.Radio.channel('entities').request('show',showId) ).done(function(data){ 
		            	if(!data.attributes.error){
							var imgs = JSON.parse(data.attributes.images);
							var img = "";
							img = _.find(imgs,function(i){ return i.profile === "show-mezzanine16x9"; }) 
							if(!img){ img = _.find(imgs,function(i){ return i.profile === "show-banner"; }) } //tv showcase image
							data.attributes.showImage = (img && img.image)?img.image:"";
							that.$el.find("#binge-programsContainer").append( _.template($("#tmpl-binge-program").html())(data.attributes) )
						}
            		});           		
            	})           		
        	}catch(e){} //we don't care to catch. If there are no programs or the JSON is broken, so be it. This is secondary content.
        }
    })
    
    
    var allKidsShowsView = Marionette.View.extend({
         template:_.template("<div><h1 class='mt2 mb0'>All WHRO Kids Programs</h1><div id='allKidsShows_Container' class='row'></div></div>")
        ,className:"binge_showlists"
        ,templateContext:{
	        
        }
        ,onRender: function() {	        
			var that = this;  
	        //get details for the programs they are associated with
        	try{
            	var showIds = JSON.parse(this.model.attributes.programIds);
            	
            	_.each(showIds,function(showId){
	            	$.when( Backbone.Radio.channel('entities').request('show',showId) ).done(function(data){ 
		            	if(!data.attributes.error){
							var imgs = JSON.parse(data.attributes.images);
							var img = "";
							img = _.find(imgs,function(i){
								return i.profile === "show-poster2x3";
							}) 
							if(!img){ img = "/assets/imgs/tvplaceholder_Poster_480x720.jpg"; }
							data.attributes.showImage = (img && img.image)?img.image:"";	
							that.$el.find("#allKidsShows_Container").append( _.template($("#tmpl-popular-programs").html())(data.attributes) );
						}
            		});            		
            	})           		
        	}catch(e){} //we don't care to catch. If there are no programs or the JSON is broken, so be it. This is secondary content.
        	
        }
    })
    return {
        show:show
    }
})();
